import styled from 'styled-components'

const _Logout = ({ className, children = 'Log out' }) => {
  return (
    <a className={className} href="/partner/logout">
      {children}
    </a>
  )
}

export const Logout = styled(_Logout)``
